import * as React from 'react';

export interface FormProps {
  name: string;
  onSubmit: (values: any) => void;
  onInvalid: (values: any) => void;
}

class Form extends React.Component<any, any> {
  // need to add hook for validation

  public render() {
    const { onSubmit, onInvalid, children, ...rest } = this.props;
    return (
      <form onSubmit={onSubmit} onInvalid={onInvalid} {...rest}>
        {children}
      </form>
    );
  }
}

export { Form };
